// extracted by mini-css-extract-plugin
export default {"header":"TheHeader_header__EaNU4","logo":"TheHeader_logo__kfXYx"};